<template>
  <v-card dark color="primary" class="pa-1">
    <v-banner class="primary" single-line>
      Discuss on Reddit!
    </v-banner>
    <v-list dense color="secondary">
      <v-list-item-group>
       <v-list-item v-for="(link, i) in redditInfo" @click="redirect(link.data.permalink)" :key="i">
        <v-list-item-content>
          <v-list-item-title>
            {{ link.data.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="redirect(subReddit.concat('/submit'))">
        <v-list-item-content>
          <v-list-item-title>
            Start a new discussion!
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      subReddit: '/r/brokenImmortals',
      redditInfo: []
    };
  },
  created() {
    fetch('https://www.reddit.com'.concat(this.subReddit).concat('/hot.json'))
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        this.redditInfo = data.data.children.filter(post => !post.data.stickied).splice(0, 5);
      });
  },
  methods: {
    redirect(url) {
      window.location.href = 'https://www.reddit.com'.concat(url);
    }
  },
  computed: {
  }
};

</script>
